import {useEffect, useRef} from "react";

import {useRegistrationWizardExperiment} from "./use_registration_wizard_experiment";

interface IUseRegistrationWizardExposureParams {
    /** The user sees the part of the page the arms of the experiment render differently */
    isExposed: boolean;
    /** The view the exposure belongs to is shown - once it is hidden, its next showing reports the exposure again */
    isViewActive?: boolean;
}

/** Reports the registration wizard exposure once per view, as soon as the user is exposed and the variant is known */
export const useRegistrationWizardExposure = ({isExposed, isViewActive = true}: IUseRegistrationWizardExposureParams) => {
    const {isResolved, trackExposure} = useRegistrationWizardExperiment({isEnabled: true});
    const hasTrackedRef = useRef(false);

    useEffect(() => {
        if (!isViewActive) {
            hasTrackedRef.current = false;
            return;
        }

        if (hasTrackedRef.current || !isExposed || !isResolved) {
            return;
        }

        hasTrackedRef.current = true;
        void trackExposure();
    }, [isViewActive, isExposed, isResolved]);
};
import {useEffect, useRef} from "react";

import {useRegistrationWizardExperiment} from "./use_registration_wizard_experiment";

interface IUseRegistrationWizardExposureParams {
    /** The user sees the part of the page the arms of the experiment render differently */
    isExposed: boolean;
    /** The view the exposure belongs to is shown - once it is hidden, its next showing reports the exposure again */
    isViewActive?: boolean;
}

/** Reports the registration wizard exposure once per view, as soon as the user is exposed and the variant is known */
export const useRegistrationWizardExposure = ({isExposed, isViewActive = true}: IUseRegistrationWizardExposureParams) => {
    const {isResolved, trackExposure} = useRegistrationWizardExperiment({isEnabled: true});
    const hasTrackedRef = useRef(false);

    useEffect(() => {
        if (!isViewActive) {
            hasTrackedRef.current = false;
            return;
        }

        if (hasTrackedRef.current || !isExposed || !isResolved) {
            return;
        }

        hasTrackedRef.current = true;
        void trackExposure();
    }, [isViewActive, isExposed, isResolved]);
};
